// shashoku options
const listMenuSystemFlags = [
  {
    id: '',
    name: '選択なし'
  },
  {
    id: 0,
    name: 'ごちめし／社食ごちめし'
  },
  {
    id: 1,
    name: 'ごちめしのみ（さきめし含む）'
  },
  {
    id: 2,
    name: '社食ごちめしのみ'
  }
];
export default listMenuSystemFlags;
